import React from 'react';

import { CategoryItem } from 'ggApp/types/api/CategoryItem';
import { getCategoryFilterSuffix } from 'ggApp/utils/urlBuilder/getCategoryFilterSuffix';

import Item from './Item';
import Wrap from './styles';

type CategoryListProps = {
    categories: CategoryItem[];
    className?: string;
    toggleSubCategories?: () => void;
    closeMenu?: () => void;
    activeCategoryIndex?: number;
    isEUNonBusinessStore: boolean;
};

export const CategoryList = ({
    className = '',
    categories = [],
    toggleSubCategories = () => undefined,
    activeCategoryIndex,
    closeMenu = () => undefined,
    isEUNonBusinessStore,
}: CategoryListProps) => {
    const clickHandler = (event: MouseEvent) => {
        if (event?.metaKey || event?.ctrlKey) return;
        closeMenu();
    };

    return (
        <Wrap className={className}>
            {categories.map((category, index) => (
                <Item
                    isActiveCategory={activeCategoryIndex === index}
                    categoryIndex={index}
                    permalink={`${category.permalink}${getCategoryFilterSuffix(
                        category,
                        isEUNonBusinessStore,
                    )}`}
                    key={category.id}
                    onClick={clickHandler}
                    name={category.name}
                    iconPath={category.icon_svg_path}
                    toggleSubCategories={toggleSubCategories}
                    subcategories={category.children}
                />
            ))}
        </Wrap>
    );
};
